<template>
  <el-select
    class="select"
    v-model="res"
    filterable
    remote
    clearable
    :size="size"
    :placeholder="`${$t('22')}、${$t('25')}、${$t('825')}`"
    value-key="staff_id"
    :remote-method="supRemoteMethod"
    :loading="supLoading"
    @change="change"
    @clear="clear"
  >
    <el-option class="res" v-for="(item, index) in supOptions" :key="index" :label="item.staff_name" :value="item">
      <img
        class="user-photo"
        style="vertical-align: middle"
        :src="item.avatar_url || getAvatar(item.sex || 0)"
        alt=""
      />
      <div class="name">
        <p>{{ item.staff_name_th }}</p>
        <p class="name_en" v-if="item.staff_name_en">{{ item.staff_name_en }}</p>
      </div>
    </el-option>
  </el-select>
</template>

<script>
import { getAvatar } from '@/util/util'
import { searchStaffFn } from 'api/org/per'
import { getCommonDepStaff } from 'api/common'

export default {
  // dataPrivilege 限制是否查看管辖范围之内的人员
  props: ['isRegister', 'comment', 'formalState', 'size', 'dataPrivilege'],
  data() {
    return {
      supLoading: false,
      supOptions: [],
      res: {}
    }
  },
  methods: {
    // 生成员工头像姓名
    getAvatar,
    supRemoteMethod(query) {
      if (query.length) {
        this.supLoading = true
        // ajax请求
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          if (this.comment === 'comment') {
            const payload = this.formalState ? { formal_state: 0, search_name: query } : { search_name: query }
            getCommonDepStaff({ ...payload, data_privilege: this.dataPrivilege }).then(res => {
              this.supLoading = false
              if (res && res.code === 1) {
                this.supOptions = res.data.map(v => ({
                  avatar_url: v.avatar_url,
                  staff_name: v.staff_name,
                  staff_name_en: v.staff_name_en,
                  staff_name_th: v.staff_name_th,
                  staff_name_secondary: v.staff_name_secondary,
                  staff_id: v.staff_id,
                  staff_code: v.staff_code,
                  mobile: v.mobile
                }))
              }
            })
          } else {
            searchStaffFn({
              search_name: query,
              page_size: 20,
              is_register_user: this.isRegister,
              data_privilege: this.dataPrivilege || 0
            }).then(res => {
              this.supLoading = false
              if (res && res.code === 1) {
                this.supOptions = res.data.map(v => ({
                  avatar_url: v.avatar_url,
                  staff_name: v.staff_name,
                  staff_name_en: v.staff_name_en,
                  staff_name_th: v.staff_name_th,
                  staff_name_secondary: v.staff_name_secondary,
                  staff_id: v.staff_id,
                  staff_code: v.staff_code,
                  mobile: v.mobile
                }))
              }
            })
          }
        }, 300)
      } else {
        this.supOptions = []
      }
    },
    change(val) {
      this.$emit(
        'change',
        val || {
          staff_name: '',
          staff_id: '',
          staff_code: '',
          mobile: ''
        }
      )
      this.$emit('input', val.staff_id || '')
    },
    clear() {
      this.supOptions = []
    }
  }
}
</script>

<style lang="scss" scoped>
.select {
  min-width: 320px;
  /deep/.el-input {
    min-width: 320px;
  }
}
.res {
  min-width: 320px;
  height: 40px;
  line-height: 40px;
  margin: 6px 0;
  display: flex;
  align-items: center;
  .name {
    padding: 4px 0 4px 8px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    p {
      line-height: 20px;
    }
  }
  .name_en {
    font-size: 12px;
    line-height: 17px;
    color: #8c8c8c;
  }
}
</style>
